import { Dictionary, DictionaryObject } from "@cawita/core-front";
import { ApiData } from "@cawita/core-front/api";
import { CwtModel } from "../modules/crud";
import { Document } from "./document.model";

export enum PresentationPageType {
    FirstPage = 'firstPagePresentation',
}

@CwtModel({ name: 'presentation-page', path: 'presentation-page' })
export class PresentationPage extends ApiData {
    type?: PresentationPageType;
    isActive?: boolean;
    name: Dictionary;
    buttonName: Dictionary;
    description: Dictionary;
    pictures: Document[];
    documents: PresentationPageDocument[];
}
export interface PresentationPageDocument extends Document {
    name?: DictionaryObject;
    description?: DictionaryObject;
}